module.exports = __webpack_public_path__ + "img/tweeter.54207224.png";